module.exports = __webpack_public_path__ + "a27458e258757d0c4ceb1eb1322216a6.png";